__turbopack_context__.v({
  "active": "NRQ01G_active",
  "desktopOnly": "NRQ01G_desktopOnly",
  "homeLink": "NRQ01G_homeLink",
  "leftColumn": "NRQ01G_leftColumn",
  "link": "NRQ01G_link",
  "logo": "NRQ01G_logo",
  "logoImage": "NRQ01G_logoImage",
  "logoText": "NRQ01G_logoText",
  "mainNav": "NRQ01G_mainNav",
  "navbar": "NRQ01G_navbar",
  "rightColumn": "NRQ01G_rightColumn",
  "search": "NRQ01G_search",
  "sidebar": "NRQ01G_sidebar",
  "sidebarBackdrop": "NRQ01G_sidebarBackdrop",
  "sidebarToggle": "NRQ01G_sidebarToggle",
  "signin": "NRQ01G_signin",
});
